import React from 'react';
import { motion } from 'framer-motion';
import Navbar from './Navbar';
import Footers from './Footer';

const Termandcondition = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      style={{ background: '#fff' }}
    >
      <div className="page-wraper term_li" style={{ background: "#fff" }}>
        <Navbar />
        <div className="page-content">
          <div
            className="wt-bnr-inr overlay-wraper bg-parallax bg-top-center"
            data-stellar-background-ratio="0.5"
            style={{ backgroundImage: "url(assets/pic/terms.webp)" }}
          >
            <div className="overlay-main bg-black opacity-07"></div>
            <div className="container">
              <div className="wt-bnr-inr-entry">
                <div className="banner-title-outer">
                  <div className="banner-title-name">
                    <h2 className="text-white">Terms & Condition</h2>
                  </div>
                </div>
                <div>
                  <ul className="wt-breadcrumb breadcrumb-style-2">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>Terms & Condition</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="section-full p-6 md:p-12" style={{ padding: '100px 0px' }}>
            <div className='container mx-auto px-4' style={{textAlign:"justify"}}>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
              >
                <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{color:'#B19777'}}>Terms & Conditions</h2>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.3 }}
              >
                 <div>
                   < h4 style={{color:'#B19777'}} >1. The Contract</ h4 >
                   <ul style={{lineHeight:'30px'}}>
                    <li>	These terms and conditions form the legally binding agreement between "CRAFTMYSPACE INTERIORS LTD” and the person signing the contract/agreeing verbally/placing the order referred to as “the Customer”. The Company Registration Number 15963804. is registered at address is Unit 1, Grange Farm, Grange Way, Iver Buckinghamshire, SL0 9NT.      Nothing in this agreement shall affect your statutory rights and it is the Customer’s responsibility to ensure all details are correct. </li>
                    <li>The company may change these terms upon giving reasonable notice of such changes, in writing, online on our website or by any other channels to the Customer.</li>
                    <li>In the event any work, materials or services are requested by any third party (which includes but is not limited to any builders, contractors, interior designers or any other person who is in the Customer’s house or who the Company reasonably believes is acting for and on behalf of the Customer) then the third party will be held responsible and liable for the agreement.</li>
                   </ul>
              </div>
              <div>
                < h4 style={{color:'#B19777'}}>2. What is not included</ h4 >
                <ul style={{lineHeight:'30px'}}>
                    <li>Re-decoration, tiling, flooring, and building work of any description or removal/disposal of old units unless specified in the order.</li>
                    <li>Disposing of any waste material, packaging or any unwanted appliances.</li>
                    <li>Installation of appliances, plumbing, gas fitting and electrics.</li>
                    <li>Any damage done to the electrical wiring and plumbing inside the walls during fitting.</li>
                </ul>
              </div>
              <div>
                < h4 style={{color:'#B19777'}}>3. Customer’s Responsibilities</ h4 >
                <ul style={{lineHeight:'30px'}}>
                    <li>Check carefully the proposed layout to make sure it is correct and meets requirements (an additional charge may have to be made if you request alternations or any additions to the design).</li>
                    <li>Give reasonable access to the premises.</li>
                    <li>Notify our technical surveying department of the whereabouts (if known) of hidden pipes or wires that may affect the proposed layout.</li>
                    <li>Move any fragile or valuable items, which could be damaged when carrying new units/appliances into the property.</li>
                    <li>Shortages or damages should be notified to the company within a reasonable time (up to 5 working days) by telephone on or after receipt of the goods.</li>

                </ul>
              </div>
              <div>
                < h4 style={{color:'#B19777'}}>4. Termination</ h4 >
                <ul style={{lineHeight:'30px'}}>
                    <li>The Customer acknowledges that the goods are made to order and cannot be resold by the Company as there is no available market. As such these are made to your specifications and are personal to you and pursuant to the Consumer Contracts (Information, Cancellation and Additional Charges) Regulations 2013, Regulation 28(b) they are exempt from the requirement to provide a 14 day cooling off period.</li>
                    <li>Once these goods are ordered, you may not cancel the contract unless we agree and the manufacturing process for your goods has not commenced. If the manufacture of the goods has commenced 50% of the contract value will be retained.</li>

                </ul>
              </div>
              <div>
                < h4 style={{color:'#B19777'}}>5. Payment</ h4 >
                <ul style={{lineHeight:'30px'}}>
                    <li>Payment may be made by means of cash, card or bank transfer</li>
                    <li>The deposit required by the company at the time of order is 50% of the total order value, 35% due on the 1st day of installation and finally 15% on completion.</li>
                    <li>All prices excluding VAT unless otherwise stated.</li>
                </ul>
              </div>
              <div>
                < h4 style={{color:'#B19777'}}>6. Installation Dates</ h4 >
                <ul style={{lineHeight:'30px'}}>
                    <li>The Company will contact the Customer to arrange installation dates based on the latest information supplied to the company by our suppliers, and therefore can be subject to change.</li>
                    <li>Any last minute changes made to the content of your order may impact on your delivery date.</li>
                    <li>If you are unable, for whatever reason, to take delivery of your goods on the confirmed delivery date, you must notify the company beforehand otherwise we reserve the right to charge you for any subsequent delivery costs.</li>

                </ul>
              </div>
              <div>
                < h4 style={{color:'#B19777'}}>7. Title to Goods</ h4 >
                <ul style={{lineHeight:'30px'}}>
                    <li>The title to and property in the goods shall remain with the Company and shall only be transferred to the Customer when the Customer has paid the Total Contract Sum in full, together with all other monies due and owing.</li>
                   

                </ul>
              </div>
              <div>
                < h4 style={{color:'#B19777'}}>8. Guarantee</ h4 >
                <ul style={{lineHeight:'30px'}}>
                    <li>For your piece of mind, we offer a 10-year guarantee on our products and 12 months workmanship providing long-term security subject to the following below.</li>
                    <li>The guarantee includes any possible damage that does not arise through improper use. For you, this means that we will deliver a replacement part to your door within a maximum of five weeks.</li>
                    <li>The guarantee excludes damage for which you are to blame i.e. the effects of external force or water damage</li>
                    <li>To make a claim, simply contact us in writing, by telephone or e-mail and we will directly find a solution together with you. By emailing and attaching a photo, we can act fast and straight away see what needs to be done.</li>
                    <li>Please note sliding wardrobe systems are equipped with bottom mounted wheels to ensure smooth and easy operation and carry a 10-year rolling gear guarantee. Mirror silvering is guaranteed for 10 years from installation and workmanship is guaranteed for 12 months following installation.</li>

                    <li>We use 18mm high-density melamine face boards (MFC) for carcases and backing to ensure stronger construction for 15 to 20 years. But we can only guarantee structure for 10 years.</li>

                  


                </ul>
              </div>
              <div>
                < h4 style={{color:'#B19777'}}>9. Specification</ h4 >
                <ul style={{lineHeight:'30px'}} >
                    <li>Fillers will be placed 50-80 mm by the walls, 80-100mm fillers on the top, 100 mm base where applicable and possible joints where width / height exceeds 2700 mm.</li>
                    <li>Variations may occur in the colour and tone of materials due to their composition. The company cannot guarantee exact colour consistency throughout the range of materials used but will achieve this within an acceptable tolerance.</li>
                    <li>Some panels are produced in decorative materials – particularly Gloss finishes – and therefore can be easily damaged and should be protected against marking. The Company is not responsible for any marking caused to any panels after installation</li>
                    <li>To make a claim, simply contact us in writing, by telephone or e-mail and we will directly find a solution together with you. By emailing and attaching a photo, we can act fast and straight away see what needs to be done.</li>
                    <li>The Customer is responsible to ensure that where necessary any planning consents or building regulations are obtained in respect of any goods provided under this agreement.</li>
                    <li>Natural wood is used in some of our products and fitted wardrobes. As a natural material wood reflects the endless variety of grains, shades and textures found in the nature and such variances can be expected. All timber products will mellow under exposure of time. PVC, laminates and melamine finishes are also subject to slight colour changes over a period of years. Unless specified otherwise, any reference made to wood or timber whether solid or veneered refers to door and drawer fronts only. Colour reproduction in our descriptive literature is as close as reproductive techniques allow. Laminate worktops with a textured finish give good wear and resistance, also colour fastness and heat resistance up to 120 degrees Celsius. The company cannot be responsible for burn marks caused by items in excess of this temperature. Worktops should not be subject to excessive heat or water as this could cause swelling of the joint. We strongly recommend the use of a chopping board when cutting.</li>

                </ul>
              </div>
              <div>
                < h4 style={{color:'#B19777'}}>10. Images</ h4 >
                <ul style={{lineHeight:'30px'}} >
                    <li>Any documents issued by the Company to the Customer at any time containing texts, designs, specifications or drawings are confidential and are the property of the Company and shall not be copied reproduced or communicated to any third party by the Customer, his workmen or agents without the prior written agreement of the Company.</li>
                    <li>By entering this agreement, the Customer hereby assigns and transfers all and any intellectual property rights in any images of the Customer’s goods, property or furniture to the Company and authorises and licences the Company to use, in any of its publicity material, such images.</li>
                    

                </ul>
              </div>
              <div>
                < h4 style={{color:'#B19777'}}>11. Survey</ h4 >
                <ul style={{lineHeight:'30px'}} >
                    <li>If at any time during or after the technical survey there is a structural, technical or costing issue prior to manufacture, the company or the customer should provide reasons for the issue within 7 days of the survey, verbally and in writing, and both parties have the right to terminate this Agreement. If the company terminates this agreement under these conditions, any deposit paid will be refunded in full. Customers should not undertake work or expense based on this contract until such time as the company has confirmed a delivery date after the technical survey and recosting has taken place and both parties have agreed any changes.</li>
                    

                </ul>
              </div>
              </motion.div>
              {/* Add more sections as needed with animations */}
            </div>
          </div>
        </div>
        <Footers />
        <button className="scroltop">
          <span className="fa fa-angle-up relative" id="btn-vibrate"></span>
        </button>
      </div>
    </motion.div>
  );
};

export default Termandcondition;
